export enum CategoriesTab {
    TEMPLATES = 'templates',
    CATEGORIES = 'categories',
}

export const isCategoriesTabValue = (value?: string | null): value is CategoriesTab =>
    value === CategoriesTab.TEMPLATES || value === CategoriesTab.CATEGORIES;

export type CategoriesTabsProps = {
    activeTab: CategoriesTab;
    onChange: (tab: CategoriesTab) => void;
};
